import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import { toast } from 'react-toastify';
import { SagaIterator } from 'redux-saga';
import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  put,
  take,
} from 'redux-saga/effects';

import { signInAPIRequest } from '../api';
import { TSignInDTO, TSignInServerResponse } from '../types';
import {
  cancelAuthTask,
  clearError,
  clearSucces,
  endAuthTask,
  onError,
  signIn,
  signInRequest,
  signOut,
  startAuthTask,
} from './auth-slice';

export function* authenticateUser(payload: TSignInDTO): SagaIterator {
  try {
    yield put(startAuthTask());
    const {
      data: { user, accessToken },
    }: TSignInServerResponse = yield call(signInAPIRequest, payload);
    yield all([
      put(
        signIn({
          token: accessToken,
          user,
        })
      ),
      put(clearError()),
    ]);
    yield call(toast, `Signed in as ${user.email}`, { type: 'success' });
  } catch (error) {
    const errorMsg = getServerErrorMessage(error);
    yield all([put(onError(errorMsg)), put(clearSucces())]);
  } finally {
    if (yield cancelled()) {
      yield all([put(signOut()), put(clearError())]);
    }
    yield put(endAuthTask());
  }
}

export function* signInFlow(): SagaIterator {
  while (true) {
    const { payload } = yield take(signInRequest);
    const signInTask = yield fork(authenticateUser, payload);

    const nextAction = yield take([cancelAuthTask, endAuthTask]);
    if (nextAction.type === cancelAuthTask.type) yield cancel(signInTask);
  }
}
